module.exports = __webpack_public_path__ + "static/img/down_btn8.cde483d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn8.png
// module id = tlom
// module chunks = 4